import GoogleMap from './GoogleMap';
import BaiduMap from './BaiduMap';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function MapBox({ storeLists, center, zoom, showLogoCard }: any) {
    const { useRouter, useEffect, useState } = useGlobal();
    const { locale } = useRouter();
    const [isClient, setIsClient] = useState(false);
    const latlngMap: any = {
        us: {
            lat: 38.0,
            lng: -77.0,
        },
        au: {
            lat: -35.2,
            lng: 149.0,
        },
        jp: {
            lat: 35.6,
            lng: 139.6,
        },
        cn: {
            lat: 39.9,
            lng: 116.4,
        },
        de: {
            lat: 52.5,
            lng: 13.4,
        },
        it: {
            lat: 41.9,
            lng: 12.5,
        },
        es: {
            lat: 40.4,
            lng: -3.7,
        },
        fr: {
            lat: 48.86,
            lng: 2.35,
        },
        eu: {
            lat: 52.5,
            lng: 13.4,
        },
        uk: {
            lat: 51.5,
            lng: -0.1,
        },
        br: {
            lat: -15.7,
            lng: -47.9,
        },
        mx: {
            lat: 19.4,
            lng: -99.1,
        },
    };
    const finalyCenter = center || (locale === 'cn' ? '北京' : latlngMap[locale || ''] || latlngMap.us);

    useEffect(() => setIsClient(true), []);

    return (
        <div className={css.mapBox}>
            {locale !== 'cn' && isClient && <GoogleMap center={finalyCenter} zoom={zoom} storeLists={storeLists} logoCard={showLogoCard} />}
            {locale === 'cn' && isClient && <BaiduMap center={finalyCenter} zoom={zoom} storeLists={storeLists} logoCard={showLogoCard} />}
        </div>
    );
}
